export default "__VITE_ASSET__1484b849__"